class PredictiveSearch extends HTMLElement {
  constructor() {
    super()

    this.lastRequestId = 0
    this.input = this.querySelector('[data-search-input]') || this.querySelector('#search-input')
    this.predictiveSearchResults = this.querySelector('[data-search-results]') || this.querySelector('#search-results')

    if (!this.input || !this.predictiveSearchResults) return

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event)
    }, 300).bind(this))

    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        const query = this.input.value.trim()
        if (query.length) {
          window.location.href = `/search?q=${encodeURIComponent(query)}`
        }
      }
    })

    this.input.addEventListener('focusout', this.debounce((event) => {
      this.onFocusOut(event)
    }, 300).bind(this))
  }

  onFocusOut() {
    $(this.predictiveSearchResults).fadeOut()
  }

  onChange() {
    const searchTerm = encodeURIComponent(this.input.value.trim())

    if (!searchTerm.length) {
      $(this.predictiveSearchResults).fadeOut(function() {
        $('.search__initial').fadeIn()
      })

      return
    }

    this.getSearchResults(searchTerm)
  }

  getSearchResults(searchTerm) {
    const requestId = ++this.lastRequestId

    fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`)
    .then((response) => {
      if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`)
      return response.json()
    })
    .then((data) => {
      if (requestId !== this.lastRequestId) return

      const products = data?.resources?.results?.products || []

      if (!products.length) {
        this.predictiveSearchResults.innerHTML = ''
        $('.navbar__search').addClass('search-results--no-results')
        this.open()
        return
      }

      $('.navbar__search').removeClass('search-results--no-results')

      const resultsMarkup = `
        <div class="search-results__grid">
          <div class="search-results__left">
            <div class="search-results__heading">
              <h4>
                Products
                <span id="search-count-products">(${products.length})</span>
              </h4>
            </div>

            <div class="search-results__products">
              ${products.map((p) => {
                const url = p.url || '#'
                const title = this.escapeHtml(p.title || '')
                const description = this.truncateWords(this.stripHtml(p.body || ''), 20)
                const imgUrl = p?.featured_image?.url || p.image || ''
                const imgAlt = this.escapeHtml(p?.featured_image?.alt || p.title || '')
                const price = this.formatMoneyFromNumberString(p.price)

                return `
                  <div class="media-object">
                    <div class="media-object-section">
                      <a class="media-object-link-overlay" href="${url}"></a>
                      <div class="thumbnail">
                        ${imgUrl ? `<img src="${imgUrl}" alt="${imgAlt}" loading="lazy">` : ``}
                      </div>
                    </div>
                    <div class="media-object-section">
                      <h5>${title} <span>&mdash; <span data-sl-attribute-p="${this.escapeHtml(String(p.id || ''))}">${price}</span></span></h5>
                      <p>${this.escapeHtml(description)}</p>
                    </div>
                  </div>
                `
              }).join('')}
            </div>
          </div>

          <div class="search-results__view-all">
            <a class="link__underline link__view-all" href="/search?q=${searchTerm}">View all</a>
          </div>
        </div>
      `

      this.predictiveSearchResults.innerHTML = resultsMarkup

      if ($('.search__initial').is(':visible')) {
        $(this.predictiveSearchResults).hide()
        $('.search__initial').fadeOut(() => this.open())
      } else {
        this.open()
      }
    })
    .catch((error) => {
      console.error(error)
      this.close()
    })
  }

  open() {
    $(this.predictiveSearchResults).fadeIn()
  }

  close() {
    $(this.predictiveSearchResults).fadeOut()
  }

  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }

  escapeHtml(str = '') {
    return String(str).replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    }[m]))
  }

  stripHtml(html = '') {
    const doc = new DOMParser().parseFromString(String(html), 'text/html')
    return (doc.body.textContent || '').trim()
  }

  truncateWords(text = '', maxWords = 20) {
    const words = String(text).trim().split(/\s+/)
    if (words.length <= maxWords) return text
    return words.slice(0, maxWords).join(' ') + '...'
  }

  formatMoneyFromNumberString(amountStr) {
    const n = Number(amountStr)
    if (!Number.isFinite(n)) return this.escapeHtml(amountStr || '')

    const currency = window.Shopify?.currency?.active || window.Shopify?.currency?.shop || 'USD'
    const locale = document.documentElement.lang || 'en'

    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(n)
    } catch {
      return n.toFixed(2)
    }
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}
